export default "__VITE_ASSET__CQFwhxFt__";